import { createAsyncThunk } from '@reduxjs/toolkit';
import type { QuizResultsData } from 'features/quizzes/types';
import { requestQuizResultsService } from 'features/quizzes/services';

export const requestQuizResults = createAsyncThunk<
  QuizResultsData,
  string,
  { rejectValue: string }
>('quizzes/requestQuizResults', async (quizId, { rejectWithValue }) => {
  try {
    return await requestQuizResultsService(quizId);
  } catch (error) {
    return rejectWithValue('Failed to fetch quiz results');
  }
});
